const env = {
  MAPS_API_KEY: 'AIzaSyAgsFgz9KguIZUdL0vBQACiLVDSqmK2vTo',
  GRAPH_HOST: process.env.REACT_APP_GRAPH_HOST
    ? process.env.REACT_APP_GRAPH_HOST
    : 'graph.api.slerp.com',
  ASSET_HOST: process.env.REACT_APP_ASSET_HOST
    ? process.env.REACT_APP_ASSET_HOST
    : 'slerp.com',
  DEFAULT_MAP_CENTER: { lat: 51.5137137, lng: -0.1285204 },
  DEFAULT_MERCHANT: 'crosstown',
  DEFAULT_SHOP: 'crosstown-soho',
  DEFAULT_API: ''
}

export default env
